module.exports = __webpack_public_path__ + "media/src/fonts/Lora-Regular-82c4adc1602e92ac1f1aa9c865a6fc07.woff";